// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// Owner 2026-10-04: "for every enrollment it should be assigned user from the pharmacists". The roster is
// the server's (mig 439 `carerx.pharmacist`); when nobody at the pharmacy holds that permission yet the
// server falls back to every CareRx staff member and the picker says so, so an admin knows to grant it.

import SearchableSelect from '../../components/common/SearchableSelect'
import { usePharmacistRoster } from '../../hooks/queries/carerxClinical'

/** Who the door preselects: the person enrolling when they are on the roster, else nobody. */
export function defaultPharmacist(roster: { id: string }[] | undefined, me: string | null | undefined): string {
  return me && roster?.some(p => p.id === me) ? me : ''
}

export default function PharmacistPicker({ value, onChange }: { value: string; onChange: (id: string) => void }) {
  const roster = usePharmacistRoster(true)
  const missing = roster.isSuccess && !value
  return (
    <label style={{ fontSize: 11.5, color: 'var(--color-text-mute)', display: 'flex', flexDirection: 'column', gap: 2 }}>
      Pharmacist *
      <SearchableSelect value={value} onChange={onChange} ariaLabel="Pharmacist"
        placeholder={roster.isPending ? 'Loading pharmacists…' : 'Choose the pharmacist…'}
        emptyText={roster.isError ? 'Pharmacist list unavailable' : 'No pharmacists at this pharmacy'}
        options={(roster.data?.items ?? []).map(p => ({ value: p.id, label: p.display_name }))} />
      {missing && <span role="alert" style={{ fontSize: 11, color: '#b23a48' }}>Every enrollment needs a pharmacist.</span>}
      {roster.data?.fallback && (
        <span style={{ fontSize: 11, color: '#b45309' }}>
          Nobody here has the “CareRx: pharmacist” permission yet, so all CareRx staff are listed — an admin can grant it in Roles.
        </span>)}
    </label>
  )
}
